import { useState, useEffect } from "react";
import svgTituloMisCursos from "../../assets/cursos/misCursos/mis cursos.svg";
import iconoUsuarioDefault from "../../assets/header/user.svg";
import { imagenesCursos } from "../../utils/diccionarioImagenes";

import "./MisCursos.css";

// Recibimos el "user" como prop (el mismo que le pasabas al carrito)
const MisCursos = ({ user, purchasedCourses=[]  }) => {
    console.log('purchasedCourses: ', purchasedCourses)

    const API_BASE = "http://localhost/backend_onelearning/api";

    // Estado solo para los cursos
    const [cursos, setCursos] = useState([]);
    const [loading, setLoading] = useState(true);

    // Solo hacemos Fetch de los cursos
    useEffect(() => {
        const fetchMisCursos = async () => {
            try {
                // Aquí llamarás a tu endpoint que trae los cursos comprados
                const response = await fetch(`${API_BASE}/courses/my_courses.php`, {
                    method: 'GET',
                    credentials: 'include' // Para que el backend sepa de qué usuario son usando la cookie
                });

                const data = await response.json();
                console.log('data:', data)
                if (data.status === 'success') {
                    setCursos(data.cursos);
                }
            } catch (error) {
                console.error("Error cargando cursos:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchMisCursos();
    }, []); // Se ejecuta una sola vez al entrar a la vista

    return (
        <>
        <section className="misCursos-section section-green">

            {/* === CONTENEDOR DEL BANNER === */}
            <div className="banner-svg-container">
                <div className="svg-wrapper">

                    <img src={svgTituloMisCursos} alt="Mis Cursos" className="img-svg-titulo" />

                    {/* LA ZONA DE LA FOTO (Usamos la foto que viene del prop 'user') */}
                    <div className="zona-interactiva-avatar-mis-cursos">
                        <div className="foto-redonda-usuario-mis-cursos">
                            {/* Si el user tiene foto, la mostramos. Si no, mostramos el default */}
                            <img
                                src={user?.photo_url ? user.photo_url : iconoUsuarioDefault}
                                alt="Mi Avatar"
                            />
                        </div>
                    </div>

                </div>
            </div>
        </section>
         {/* === CONTENEDOR DE CURSOS === */}
            <div className="container" style={{ marginTop: '40px', minHeight:'300px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                {purchasedCourses.length === 0 ? (
                <div style={{ textAlign: 'center', color: 'black'}}>
                    <h3>Aún no tienes cursos activos</h3>
                    <p>¡Explora nuestro catálogo y empieza a aprender!</p>
                </div>
            ) : (
                    <div className="grid-mis-cursos">
                        {/* Aquí harás el .map() para dibujar las tarjetas de los cursos */}
                            {purchasedCourses.map(curso => (
                                <div key={curso.id} className="item-curso-container">
                                    <h3>{curso.title}</h3>
                                <div className="tarjeta-cuadrada">
                                    {/* Usamos el diccionario importado */}
                                    
                                    <img
                                        src={imagenesCursos[curso.id] ? imagenesCursos[curso.id].desktop : "https://via.placeholder.com/300x200?text=Sin+Foto"}
                                        alt={curso.titulo}
                                        className="imagen-curso"
                                    />
                                </div>
                                <button
                                    className="button"
                                    onClick={() => alert(`Cargando recursos para el curso: ${curso.id}`)}
                                >
                                    Recursos
                                </button>
                            </div>
                        ))}
                    </div>
                )}
            </div>

        </>
    );
};

export default MisCursos;